import type { AccessPermissions } from '@/types/permission';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { IVerifyUser } from './auth.types';
import type { IBranch } from '../user-access/user-access.types';

type AuthState = {
  access_token?: string;
  permissions?: AccessPermissions;
  user?: IVerifyUser;
  selectedBranch?: IBranch;
  setToken?: (token: string) => void;
  removeToken?: () => void;
  setPermissions: (permissions: AccessPermissions | undefined) => void;
  setUser: (user: IVerifyUser | undefined) => void;
  setSelectedBranch: (branch?: IBranch) => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      access_token: undefined,
      permissions: undefined,
      user: undefined,
      selectedBranch: undefined,
      setToken: data => set({ access_token: data }),
      removeToken: () => {
        set({ access_token: undefined });
        localStorage.removeItem('auth');
      },

      setPermissions: data => set({ permissions: data }),
      setUser: data => set({ user: data }),
      setSelectedBranch: data => set({ selectedBranch: data }),
    }),
    {
      name: 'auth',
      partialize: state => ({
        user: state.user,
        access_token: state.access_token,
      }),
    }
  )
);
